export default "__VITE_ASSET__CTouj6Ld__"